import { WUKONG_DOMAIN } from '@/utils/env';

export const removeStorage = (language: string) => {
  if (localStorage.getItem('isDeviceDetectSuccess')?.includes('fail')) {
    console.log('>>>remove detect store');
    let iframe = document.createElement('iframe') as HTMLIFrameElement | undefined;
    if (iframe) {
      iframe.style.display = 'none';
      iframe.src = `https://h5-static.talk-cloud.net/static/wukong_device/index.html#/?domain=${WUKONG_DOMAIN}&ts=${Date.now()}&lang=${
        language === 'zh' ? 'zh-cn' : 'en-us'
      }&iswizard=1&isreset=1`;
      iframe.allow = 'camera *; microphone *; autoplay *; midi *; encrypted-media *;';
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe?.remove();
        iframe = undefined;
      };
    }
  }
};

export default {};
